import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './App.css'
import App from './App'
import i18n from './i18n'
import { getTrackedParamsFromURL } from './util/trackedURLParams'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

const params = getTrackedParamsFromURL()
if (params.language === 'en' || params.language === 'es') {
  i18n.changeLanguage(params.language)
}

import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './posthog'
import { captureException } from './analytics'
import { PostHogErrorBoundary } from 'posthog-js/react'
import ErrorFallback from './components/ErrorFallback'
import { MapTooltipMachineProvider } from './contexts/MapTooltipMachineContext'

import toast, { Toaster } from 'react-hot-toast'

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      captureException(error)
      toast.error(i18n.t('errors.somethingWentWrong'))
    },
  }),
})
const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MapTooltipMachineProvider>
        <PostHogErrorBoundary fallback={<ErrorFallback />}>
          <App />
        </PostHogErrorBoundary>
        <Toaster position="bottom-center" />
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
      </MapTooltipMachineProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
